// @ts-nocheck
import React, { useEffect, useState } from 'react';
import '../../styles/projectspage.css';
import { FiCircle } from 'react-icons/fi';
import {
	KeyboardDoubleArrowLeft,
	KeyboardDoubleArrowRight,
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import remarkHTML from 'remark-html';
import Loader from '../../components/Loader';
import queryString from 'query-string';
import { services } from '../../apis';
import { useSelector } from 'react-redux';
import remarkGfm from 'remark-gfm';
import {
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Toolbar,
} from '@mui/material';
import { FaCheckCircle } from 'react-icons/fa';
import { BiLockAlt } from 'react-icons/bi';

const StartProjectPage = () => {
	//@ts-ignore
	const projectId: string = queryString.parse(location.search).project;
	const [projectSteps, setProjectSteps] = useState([]);
	const [activeStepIndex, setActiveStepIndex] = useState(1);
	const [loading, setLoading] = useState(false);

	const userState = useSelector((state: any) => state.user);
	const { user } = userState;

	const plugInUserEmail = (stepContent :string) => {
		//look for string {#$%tallyemail} and replace it with the user's email
		
			return stepContent.replace('{#$%tallyemail}', user.email);
		

	}
	const getProjectSteps = async () => {
		setLoading(true);
		console.log(projectId, 'projId');
		const steps = await services.courseService.getProjectSteps(projectId);
		setProjectSteps(steps);
		
		console.log(steps, 'steps');
		setLoading(false);
	};
	useEffect(() => {
		getProjectSteps();
	}, []);

	useEffect(() => {
		if(user){
			let emailProjectSteps = projectSteps;
			emailProjectSteps.forEach(e=>{
				e.content=plugInUserEmail(e.content);
			}) 
			// emailProjectSteps[emailProjectSteps.length-1].content = plugInUserEmail(emailProjectSteps[emailProjectSteps.length-1].content);
			setProjectSteps([...emailProjectSteps]);
		}
	}, [user]);

	const renderStepsList = () => (
		<Box
			sx={{
				width: 250,
			}}
			role="presentation"
			onClick={() => {}}
			onKeyDown={() => {}}
		>
			<List>
				{/* <ListItem>
					<h2>Project Steps</h2>
				</ListItem> */}
				<Toolbar />
				{/* <Divider /> */}
				{projectSteps.map((step) => (
					<ListItem
						key={step.name}
						disablePadding
						disabled={
							!step.isCompleted && step.index != activeStepIndex
						}
					>
						<ListItemButton
							selected={step.index == activeStepIndex}
							disabled={
								!step.isCompleted && step.index != activeStepIndex
							}
							onClick={() => {
								if(!step.isCompleted && step.index != activeStepIndex){
									return;
								}
								setActiveStepIndex(step.index);
							}}
						>
							<ListItemIcon
								style={{ minWidth: 0, marginRight: 9 }}
							>
								{step.isCompleted && <FaCheckCircle />}
								{!step.isCompleted &&
									step.index == activeStepIndex && (
										<FiCircle />
									)}
								{!step.isCompleted &&
									step.index != activeStepIndex && (
										<BiLockAlt />
									)}
							</ListItemIcon>
							<ListItemText primary={step.name} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Box>
	);

	const handlePrev = () => {
		if (activeStepIndex == 1) {
			return;
		}
		setActiveStepIndex(activeStepIndex - 1);
	};

	const postMarkCompleted = async (projectId, stepId) => {
		await services.courseService.markStepComplete(projectId, stepId);
	};
	const handleNext = () => {
		let newProjectSteps = [...projectSteps];
		newProjectSteps[activeStepIndex - 1].isCompleted = true;
		postMarkCompleted(projectId, newProjectSteps[activeStepIndex - 1].id);
		setProjectSteps(newProjectSteps);

		if (activeStepIndex == projectSteps.length) {
			return;
		}
		setActiveStepIndex(activeStepIndex + 1);
	};

	return (
		<>
			<div className={'markdown-content'}>
				{loading ? (
					<Loader />
				) : (
					<>
						<ReactMarkdown
							className="markdown-body"
							rehypePlugins={[[rehypeHighlight], [rehypeRaw]]}
							remarkPlugins={[remarkGfm, remarkHTML]}
						>
							{projectSteps[activeStepIndex - 1] && projectSteps[activeStepIndex - 1].content}
						</ReactMarkdown>
						<div className="projects_bottombar">
							<a
								className="notes_leftbox"
								onClick={(e) => {
									e.preventDefault();
									handlePrev();
								}}
								style={{
									visibility:
										activeStepIndex != 1
											? 'visible'
											: 'hidden',
								}}
							>
								<p>Prev</p>
								<p className="notes_bottomlabel">
									{' '}
									<KeyboardDoubleArrowLeft
										style={{
											fontSize: '1.2rem',
										}}
									/>
									<p style={{ margin: '0 10px 0' }}>
										Go to Previous step
									</p>{' '}
								</p>
							</a>
							<a
								onClick={(e) => {
									e.preventDefault();
									handleNext();
								}}
								className="notes_rightbox"
							>
								<p
									style={{
										visibility:
											activeStepIndex !=
											projectSteps.length
												? 'visible'
												: 'hidden',
									}}
								>
									Next
								</p>
								<p
									className="notes_bottomlabel"
									style={{ justifyContent: 'flex-end' }}
								>
									<p style={{ margin: '0 10px 0' }}>
										Mark as Done
									</p>{' '}
									<KeyboardDoubleArrowRight
										style={{ fontSize: '1.2rem' }}
									/>
								</p>
							</a>
						</div>
					</>
				)}
			</div>
			<div>
				<React.Fragment key={'right'}>
					<Drawer
						anchor={'right'}
						open={true}
						onClose={() => {}}
						variant="permanent"
					>
						{renderStepsList()}
					</Drawer>
				</React.Fragment>
			</div>
		</>
	);
};

export default StartProjectPage;
